<template>
  <v-container style="max-width:1200px" class="pt-0 mt-0">
    <ASearchForm
      :modelName="'User'"
      :create="hasEditPermission"
      :dropdownProps="[{type:'text',name: 'UserName / Email / Name (contains)', payloadKey: 'userName', morePayloadKeys: ['email','firstName','lastName']}, {model:'roles', name: 'Role', payloadKey: 'roleId'}]"
      @change="search"
      @create="onCreate"
      ref="ASearchForm"
      class="mb-5"
    ></ASearchForm>
    <ADataTable
      :headers="headers"
      :api="api"
      :sortBy="'userName'"
      :editAction="hasEditPermission"
      :deleteAction="false"
      :exportable="true"
      @click:edit="onEdit"
      :hideTitleBar="true"
      :apiParams="apiParams"
      ref="table"
    ></ADataTable>
    <AFormDialog
      ref="formDialog"
      :fields="formMeta"
      :modelName="'User'"
      :model="'users'"
      @modified="load"
    ></AFormDialog>
  </v-container>
</template>

<script>
import userApi from "../api/user";
import snackbar from "../mixins/snackbar";
import CRUDFuncsMixin from "../mixins/CRUDFuncs";
import confirmDialogMixin from "../mixins/ConfirmDialogMixin";
import MessageDialogMixin from "../mixins/MessageDialogMixin";
import PermissionsHelper from "../mixins/PermissionsHelper";
import ASearchForm from "../components/ASearchForm";
import AFilterInfo from "../components/AFilterInfo";
import ADataTable from "../components/ADataTable";
import AFormDialog from "../components/AFormDialog";
import formMeta from "./formdata/user";
import axios from "../api/axios";

export default {
  name: "Users",
  components: {
    ASearchForm,
    AFilterInfo,
    ADataTable,
    AFormDialog
  },
  mixins: [
    snackbar,
    CRUDFuncsMixin,
    PermissionsHelper,
    PermissionsHelper,
    confirmDialogMixin,
    MessageDialogMixin
  ],
  data() {
    return {
      model: "users",
      headers: [
        { text: "First Name", value: "firstName", sortable: true },
        { text: "LastName", value: "lastName", sortable: true },
        { text: "Username", value: "userName", sortable: true },
        { text: "Email", value: "email", sortable: true },
        {
          text: "Role",
          value: "roleName",
          sortable: true,
          cusOrderByName: "roleId"
        },
        {
          text: "Status",
          value: "status",
          sortable: true,
          format: {
            value: "active",
            formatter: v => (v ? "Enabled" : "Disabled")
          }
        }
      ],
      apiParams: {},
      formMeta: formMeta.fields
    };
  },
  methods: {
    search(payload) {
      this.apiParams = payload;
    }
  }
};
</script>

